import { createFileRoute } from '@tanstack/react-router';
import { PortalNumbers } from '@/features/portal/PortalNumeri';

/**
 * «Numeri» — la sezione che il BE riserva al portale e che qui mancava. Non è la panoramica:
 * quella dice come sta andando adesso, questa cosa è successo finora.
 */
export const Route = createFileRoute('/_portal/portal/numeri')({ component: PortalNumbers });
